<!-- 載入中 -->
<template>
    <div class="loading-mask"
    :class="{'show': show }"
    v-show="isDisplay">
        <div class="loading-container">
            <img src="@/assets/images/loading/img_loading_logo@3x.png" alt="返校實境體驗展" class="logo">
            <p v-text="percent"></p>
        </div>
    </div>
</template>

<script type="text/javascript">
export default {
    props: {
        show: {
            type: Boolean,
            default: false,
            required: true,
        },
        percent: {
            type: String,
            default: '零',
        },
    },
    data() {
        return {
            isDisplay: true,
        };
    },
    watch: {
        show(val) {
            if (!val) {
                window.setTimeout(() => {
                    this.isDisplay = val;
                }, 800);
            } else {
                this.isDisplay = val;
            }
        },
    },
};
</script>

<style lang="sass" scoped>

@keyframes blackRun
    0%
        opacity: 1
    50%
        opacity: 0
    70%
        opacity: 1
    100%
        opacity: 1

.loading-mask
    background-image: url('../assets/images/loading/bg_loading@2x.png')
    background-color: #362e2b
    background-repeat: no-repeat
    background-position: 50% 100%
    background-size: cover
    width: 100vw
    height: 100vh
    top: 0
    left: 0
    position: fixed
    opacity: 0
    transition: .8s ease-in-out
    z-index: 10
    &:after
        background-color: rgba(#000, .3)
        content: ''
        display: block
        height: 100vh
        animation-name: blackRun
        animation-duration: 2s
        animation-iteration-count: infinite
        animation-timing-function: ease-in
        animation-delay: 500ms
    &.show
        opacity: 1

@keyframes fireRun
    0%
        background-size: auto 75%
    50%
        background-size: auto 95%
    70%
        background-size: auto 75%
    100%
        background-size: auto 75%

.loading-container
    $s: 28vh
    background-image: url('../assets/images/loading/img_loading_candle@2x.png')
    background-repeat: no-repeat
    background-position: 50% 100%
    background-size: contain
    position: absolute
    text-align: center
    top: 14vh
    left: calc(50% - 14vh)
    width: $s
    height: $s * 1.6
    z-index: 2
    &:before
        background-image: url('../assets/images/loading/img_loading_fire@2x.png')
        background-repeat: no-repeat
        background-position: bottom
        background-size: auto 80%
        content: ''
        display: inline-block
        position: absolute
        $s: 10.2vh
        top: 0
        left: 0
        width: 100%
        height: $s
        animation-name: fireRun
        animation-duration: 2s
        animation-iteration-count: infinite
        animation-timing-function: ease-in
        animation-delay: 500ms
    .logo
        $s: 17vh
        position: absolute
        bottom: -19vh
        left: calc(50% - 17vh)
        width: $s * 2
    p
        color: #c1282d
        font-size: 1.2em
        position: relative
        top: 65vh

@media (min-width: 768px)
    .loading-mask
        background-image: url('../assets/images/loading/bg_loading@3x.png')
</style>
